import { render, staticRenderFns } from "./MyStudents.vue?vue&type=template&id=2d5b4876"
import script from "./MyStudents.vue?vue&type=script&lang=js"
export * from "./MyStudents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d5b4876')) {
      api.createRecord('2d5b4876', component.options)
    } else {
      api.reload('2d5b4876', component.options)
    }
    module.hot.accept("./MyStudents.vue?vue&type=template&id=2d5b4876", function () {
      api.rerender('2d5b4876', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/lesson/teacher/MyStudents.vue"
export default component.exports